import React from 'react';
import Currency from '../components/Currency/Currency';

const CurrencyPage = () => {
  return (
    <>
      <Currency />
    </>
  );
};

export default CurrencyPage;
